export * from './Avatar';
export * from './Badge/';
export * from './Button';
export * from './Card';
export * from './IconContainer';
export * from './Input';
export * from './Switch';
export * from './Tag';

// New components with default exports
export { default as FeatureCard } from './FeatureCard';
export { default as GradientIcon } from './GradientIcon';
export { default as SectionBadge } from './SectionBadge';
export { default as SectionHeader } from './SectionHeader';

// Data display components
export { default as EmptyState } from './EmptyState';
export { default as ErrorMessage } from './ErrorMessage';
export { default as LoadingSpinner } from './LoadingSpinner';

// Interactive components
export { Modal } from './Modal';
export { Tabs } from './Tabs';
export { Dropdown } from './Dropdown';
export { Accordion } from './Accordion';

// Re-export types
export type { AvatarProps } from './Avatar';
export type { FeatureCardProps } from './FeatureCard';
export type { GradientIconProps } from './GradientIcon';
export type { SectionBadgeProps } from './SectionBadge';
export type { SectionHeaderProps } from './SectionHeader';
